import { MembersState } from '@libs/src/accounts/members.interfaces';
import { DataDashboard } from '@libs/src/data-dashboard/data-dashboard.interface';
import { FeedbackSubmission } from '@libs/src/feedback-submission/feedback-submission';
import { GroupsState } from '@libs/src/groups/groups-store/groups.interfaces';
import { IcebreakerState } from '@libs/src/icebreakers-store/icebreakers-store.state';
import { Account } from '@libs/src/models/account.model';
import {
  ConversationsSearchState,
  ConversationState,
} from '@libs/src/models/conversation.interfaces';
import { Group } from '@libs/src/models/group.model';
import {
  MatchConfig,
  MatchCycle,
  MatchState,
} from '@libs/src/models/match.interfaces';
import { OpportunitySubmissionState } from '@libs/src/models/opportunitySubmissions.interfaces';
import { NotesState } from '@libs/src/notes/notes-store.state';
import { Tenant } from '@libs/src/tenant/tenant.interface';
import { GroupMatchesState } from '@main-client/src/app/group-intro-dashboard/group-matches/group-matches-state.interface';
import {
  Opportunity,
  OpportunityState,
} from '@main-client/src/app/opportunity/opportunity.model';
import { Profile } from '@main-client/src/app/profile/profile';

export interface IAppState {
  conversations: ConversationState[];
  conversationsSearch: ConversationsSearchState;
  currentGroup: string;
  dataDashboard: DataDashboard;
  events: EventState;
  eventSaving: { [eventId: string]: boolean };
  feed: FeedState;
  groupMatches: GroupMatchesState;
  groups: GroupsState[];
  header: IHeaderState;
  sideNav: ISideNavState;
  hubs: HubsState;
  icebreakers: IcebreakerState;
  matches: MatchState[];
  matchConfigs: {
    count: number;
    items: MatchConfig[];
  };
  members: MembersState;
  news: NewsState;
  notes: NotesState;
  notifications: INotificationState;
  opportunities: OpportunityState[];
  opportunitiesSubmissions: OpportunitySubmissionState[];
  profile: IProfileState;
  tenant: Tenant;
  upload: { imageUrl: string; inProgress: boolean };
  user: Account;
}

export interface Error {
  message?: string;
  name?: string;
  status?: number;
}

export interface EventState {
  items: Opportunity[];
  totalCount: number;
  countPerFilter?: FilterCountMap;
  totalPerFilter?: FilterCountMap;
}

export interface FilterCountMap {
  draft?: number;
  past?: number;
  requested?: number;
  rsvps?: number;
  upcoming?: number;
}

export interface HubsState {
  searchFilters?: Record<string, string[] | string>;
  isLoading?: boolean;
  items: Group[];
  keyword?: string;
  totalCount: number;
}

export interface FeedState {
  [groupId: string]: FeedGroupState;
}

export interface FeedGroupState {
  currentMatch: any;
  currentMatchFeedbackSubmissions: FeedbackSubmission;
  isInitialized: boolean;
  isLoading: boolean;
  isCurrentMatchLoading: boolean;
  isPastMatchesLoading: boolean;
  feedbacks: any[];
  matches: any[];
  matchConfigs: {
    count: number;
    items: MatchConfig[];
  };
  matchCycles: {
    count: number;
    items: MatchCycle[];
  };
  matchCyclePreview: MatchCycle;
}

export interface IHeaderState {
  show: boolean;
  unseenConversationsCount: number;
  unseenNotificationsCount: number;
}

export interface ISideNavState {
  show: boolean;
}

export interface INotificationState {
  isLoaded: boolean;
  items: any[];
}

export interface IProfileState {
  isLoaded: boolean;
  isEdited: boolean;
  body: Profile;
}

export interface NewsState {
  items: Opportunity[];
  totalCount: number;
  isLoaded: boolean;
  error: Error;
  type: string;
}

export enum ProfileMessageStatus {
  started,
  sent,
  none,
}
